/**
 * Determines the status color for a category row based on success/error timestamps.
 * - red  : has an error more recent than the last success (or no success at all)
 * - green: has a success timestamp
 * - gray : no data at all
 */
export function resolveRowStatus(category) {
    const { lastSuccessAt, lastErrorAt } = category;
    if (lastErrorAt) {
        if (!lastSuccessAt || new Date(lastErrorAt) > new Date(lastSuccessAt)) {
            return 'red';
        }
    }
    if (lastSuccessAt)
        return 'green';
    return 'gray';
}
/**
 * Returns the most-recent-error category across all categories that are red.
 */
export function findMostRecentError(categories) {
    var _a;
    const redCategories = categories.filter((cat) => resolveRowStatus(cat) === 'red' && cat.lastErrorAt !== null);
    redCategories.sort((a, b) => new Date(b.lastErrorAt).getTime() - new Date(a.lastErrorAt).getTime());
    return (_a = redCategories[0]) !== null && _a !== void 0 ? _a : null;
}
